import api from 'api/axios';

export async function getSubscriptionPlans(text) {
  try {
    const query = text ? `?text=${encodeURIComponent(text)}` : "";
    return await api.get(`/subscription${query}`);
  } catch (err) {
    return err.response;
  }
}

export async function updateSubscriptionPlan(id, payload) {
  try {
    return await api.patch(`/subscription/${id}`, payload);
  } catch (err) {
    return err.response;
  }
}
